import { useState, useMemo } from "react";
import { lib } from "react-single-app";

/**
 *
 * @return {string}
 */
export default function useRootPath() {
    const [rootPath, setRootPath] = useState();
    useMemo(() => {
        let rootPath = lib.config.webToken == "admin" ? "/login-admin" : "/login";
        setRootPath(rootPath);
    }, [lib.config.webToken]);
    return rootPath;
}
